var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMohawk(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.1 108.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:#59ac31;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.02,62.78c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.03,55.91l-12.62-4.12c-.79-.26-1.22-1.11-.97-1.9s1.11-1.23,1.9-.97l12.62,4.12c.79,.26,1.22,1.11,.97,1.9s-1.11,1.23-1.9,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.66,55.91l12.62-4.12c.79-.26,1.22-1.11,.97-1.9s-1.11-1.23-1.9-.97l-12.62,4.12c-.79,.26-1.22,1.11-.97,1.9s1.11,1.23,1.9,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.49,62.78c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.29,42.6c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3s-1.3-.58-1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.49,86.24c-8.33,0-15.98-3-19.95-7.83-.77-.94-.64-2.32,.3-3.09,.94-.77,2.32-.64,3.09,.3,3.11,3.79,9.61,6.23,16.56,6.23s13.2-2.32,16.41-6.06c.79-.92,2.18-1.03,3.1-.23,.92,.79,1.03,2.18,.24,3.1-4.02,4.68-11.59,7.59-19.74,7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,108.44C21.11,108.44,0,87.34,0,61.39S21.11,14.34,47.05,14.34s47.05,21.11,47.05,47.05-21.11,47.05-47.05,47.05Zm0-90.72C22.97,17.72,3.38,37.31,3.38,61.39s19.59,43.67,43.67,43.67,43.67-19.59,43.67-43.67S71.13,17.72,47.05,17.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.63,.03v-.03c-.25,0-.49,0-.74,.01-.24,0-.49-.01-.74-.01V.03c-12.82,.49-16.9,7.3-16.19,7.85,9.57,12.38,10.3,28.13,10.3,28.13h13.24s.74-15.75,10.3-28.13c.71-.54-3.37-7.36-16.19-7.85Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMohawk);
export default __webpack_public_path__ + "static/media/Mohawk.621e36ff643dce3b63312982cceaf6e2.svg";
export { ForwardRef as ReactComponent };